import Vue from 'vue';
// import 'bootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import Vue2TouchEvents from 'vue2-touch-events';
import { BootstrapVue, IconsPlugin, VBTooltipPlugin } from 'bootstrap-vue';

import App from './App.vue';

// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
// Vue2touchEvent
Vue.use(Vue2TouchEvents);

Vue.use(VBTooltipPlugin);


Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
}).$mount('#app');
